import { Box, Container, Grid, Sheet, Stack, Typography } from '@mui/joy';
import {
    ShieldCheck,
    Key,
    GithubLogo,
    SealCheck,
    PlugsIcon,
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';
import { IconBadge } from './IconBadge';

const SECURITY = [
    { icon: Key, title: 'Вход без пароля', text: 'Вы входите по одноразовому коду из почты или через <nobr>Яндекс ID</nobr>.' },
    { icon: PlugsIcon, title: 'Шифрованное соединение', text: 'Весь трафик между вами и сервером передаётся по защищённому каналу.' },
    { icon: SealCheck, title: 'Защита сессий', text: 'Доступ работает на токенах с автоматическим обновлением и защитой от подделки запросов.' },
    { icon: GithubLogo, title: 'Открытый код', text: 'Клиентская часть с открытым исходным кодом. Можно изучить, как всё устроено.' },
];

export function SecuritySection() {
    return (
        <Container maxWidth="lg" id="security" sx={{ scrollMarginTop: '88px' }}>
            <FadeIn y={40}>
                <Sheet
                    variant="soft"
                    sx={{
                        my: { md: 12, xs: 6 },
                        p: { xs: 4, md: 8 },
                        borderRadius: '32px',
                        backgroundColor: 'rgba(72, 190, 186, 0.06)',
                    }}
                >
                    <Stack alignItems="center" sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                        <Box sx={(theme) => ({ color: 'var(--joy-palette-primary-500)', mb: 1.5, [theme.getColorSchemeSelector('dark')]: { color: '#fff' } })}>
                            <ShieldCheck size={60} weight="fill" />
                        </Box>
                        <Typography level="h2" sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, mb: 1 }}>
                            Безопасность по умолчанию
                        </Typography>
                        <Typography level="body-lg" sx={{ color: 'text.secondary', maxWidth: 620 }}>
                            Мы собираем минимум информации, чтобы не создавать рисков.
                            Есть модерация контента, жалобы и блокировки.
                        </Typography>
                    </Stack>
                    <Grid container spacing={3}>
                        {SECURITY.map((s, i) => (
                            <Grid key={s.title} xs={12} sm={6} md={3}>
                                <FadeIn delay={i * 0.08}>
                                    <Box sx={{ height: '100%' }}>
                                        <IconBadge icon={s.icon} />
                                        <Typography level="title-md" sx={{ fontWeight: 700, mb: 0.75 }}>
                                            {s.title}
                                        </Typography>
                                        <Typography level="body-sm" sx={{ color: 'text.secondary' }}>
                                            <span dangerouslySetInnerHTML={{ __html: s.text }} />
                                        </Typography>
                                    </Box>
                                </FadeIn>
                            </Grid>
                        ))}
                    </Grid>
                </Sheet>
            </FadeIn>
        </Container>
    );
}
